var ExtRestConfig = /** @class */ (function () {
    function ExtRestConfig(config) {
        if (config.basePath)
            this.basePath = config.basePath;
    } // constructor
    return ExtRestConfig;
}());
export { ExtRestConfig };
//# sourceMappingURL=extRest.conf.js.map